import { render, staticRenderFns } from "./PlaceLosBarriles.vue?vue&type=template&id=55d65896&scoped=true&"
import script from "./PlaceLosBarriles.vue?vue&type=script&lang=js&"
export * from "./PlaceLosBarriles.vue?vue&type=script&lang=js&"
import style0 from "./PlaceLosBarriles.vue?vue&type=style&index=0&id=55d65896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d65896",
  null
  
)

export default component.exports